import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyGuestCarDetails = loadable(() => import(/* webpackChunkName: "content/car/details/guest" */ './GuestCarDetails'), 'GuestCarDetails');
